<template>
  <div class="blocks">
    <div class="top">当日订单概况</div>
    <div class="blossomVideo">
      <div id="pieecharts" :style="pieStyle"></div>
      <div class="bottom">
        <div class="bg">
          <!-- <span v-for="(item,index) in bgData" :key="index">
            总任务量:
            <i>{{item}}个</i>
          </span> -->
           <span>
            总任务量:
            <i>{{bgData.sum}}个</i>
          </span>
          <span>
            执行中:
            <i>{{bgData.execution}}个</i>
          </span>
          <span>
            已完成:
            <i>{{bgData.accomplish}}个</i>
          </span>
          <span>
            待执行:
            <i>{{bgData.toperform}}个</i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//这是饼状图组件
export default {
  name: "echarts04",
  props: {
    pieStyle: {
      type: Object,
      default: () => {
        return { width: "300px", height: "120px" };
      }
    },
    bgData: {
      type: Object,
      default: () => {
        return {
          sum: "100",
          execution: "20",
          accomplish: "30",
          toperform: "50"
        };
      }
    },
    echaresData: {
      type: Array,
      default: () => {
        return [
          { value: 20, name: "执行中" },
          { value: 30, name: "待执行" },
          { value: 50, name: "已完成" }
        ];
      }
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.pies();
  },
  methods: {
    pies() {
      var _this = this;
      var behaviorpie = this.$echarts.init(
        document.getElementById("pieecharts")
      );
      var option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)"
        },

        series: [
          {
            // name: "当日订单占比",
            type: "pie",
            radius: ["58%", "72%"],
            color: [
              {
                type: "radial",
                x: 0.4,
                y: 0.2,
                r: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: " #3659F7" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(27, 40, 208, .8)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              },
              {
                type: "radial",
                x: 0.7,
                y: 0.4,
                r: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#00FD98" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 189, 207, .8)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              },
              {
                type: "radial",
                x: 0.8,
                y: 0.5,
                r: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#FFB51B" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(249, 54, 45, .8)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            ],
            label: {
              normal: {
                // formatter: "{b}\n{d}%"
                formatter: "{d}%",
                color: "#58dcp"
              }
            },
            data: _this.echaresData
          }
        ]
      };
      behaviorpie.setOption(option);
    }
  }
};
</script>
<style  scoped>
.blocks {
  width: 318px;
  height: 222px;
  background: url("../../assets/img/title-bg.png") no-repeat;
  position: relative;
  border-radius: 8px; 
}
.top {
  position: absolute;
  left: 85px;
  top: -12px;
  width: 150px;
  height: 32px;
  color: #796423;
  text-align: center;
  line-height: 32px;
  background-image: linear-gradient(to right,#f8f1d5, #ffffff);
  border-radius: 8px;
}
.blossomVideo {
  width: 300px;
  height: 180px;
  position: absolute;
  top: 32px;
  left: 9px;
  border-radius: 6px;
}
.bottom {
  width: 100%;
  height: 61px;
}
.bg {
  background: url("../../assets/img/bing-bg.png") no-repeat;
  width: 273px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.bg span {
  color: #03adb9;
  display: inline-block;
  width: 44%;
  text-align: left;
  padding-top: 5px;
  padding-left: 15px;
  font-size: 14px;
  font-weight: 600;
}
.bg span i {
  color: #11644a;
  font-size: 18px;
  margin-left: 4px;
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts04.vue